<template>
	<section class="card">
		<span>{{number}}</span>
		<p class="title">
			<slot name="title" v-html="titleHtml">{{text}}</slot>
		</p>
		<p class="text">
			<slot name="text">{{text}}</slot>
		</p>
	</section>
</template>

<script>
export default {
	props: ['number', 'title', 'text'],
	computed: {
		titleHtml() {
			return this.title.replace(/\n/g, '<br>');
		}
	}
}
</script>

<style scoped>
.card {
	font-size: 13px;
	box-sizing: border-box;
	padding: 20px 20px 20px 20px;
	background: rgb(226,226,226);
	background: linear-gradient(0deg, rgba(226,226,226,1) 0%, rgba(245,245,245,1) 48%, rgba(253,253,253,1) 100%);
}
span {
	font-size: 40px;
}
p {
	margin-top: 0;
}
.text {
	text-align: justify;
	color: #686868;
	font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Card.vue